import React from 'react';
import Card from '@material-ui/core/Card';
import CardActionArea from '@material-ui/core/CardActionArea';
import CardMedia from '@material-ui/core/CardMedia';
import Typography from '@material-ui/core/Typography';
import PropTypes from 'prop-types';

const TeamCard = ({staff}) => {
  return (
    <>
      <Card
        elevation={0}
        justify="center"
        style={{backgroundColor: 'transparent'}}
      >
        <CardActionArea>
          <CardMedia
            alt={staff.alt}
            component="img"
            image={staff.img}
            object-fit
            style={{padding: '1.8rem'}}
            title={staff.firstName + staff.lastName}
          />
        </CardActionArea>
      </Card>
      <Typography
        style={{marginTop: '', fontWeight: 'bold', fontSize: 'rem', overflowWrap: 'normal'}}
      >
        {staff.firstName}&nbsp;{staff.lastName}
      </Typography>
      <Typography
        style={{fontSize: '0.8rem'}}
      >
        {staff.assignment}
      </Typography>
    </>
  );
}

TeamCard.propTypes = {
  staff: PropTypes.object,
};


export default TeamCard;
